import { TAnswerState } from '../../../../containers/FormContainer/types/internal';

export const defaultMapper = (answerState: TAnswerState) => {
  return { [answerState.answerField]: answerState.value };
};
